import React from 'react'
import PropTypes from 'prop-types'
import { Spinner } from '@olxbr/ds-web'

export const LoadingSpinner = ({ label, 'aria-label': ariaLabel, size }) => {
  return (
    <div className="flex flex-col items-center">
      <Spinner size={size} aria-label={ariaLabel} />
      {label && <span className="typo-body-small mt-2">{label}</span>}
    </div>
  )
}

LoadingSpinner.defaultProps = {
  size: 'large',
}

LoadingSpinner.propTypes = {
  label: PropTypes.string,
  size: PropTypes.string,
  'aria-label': PropTypes.string.isRequired,
}
